module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "calibre_pb_0"
    }
  }, [_c('p', {
    staticClass: "calibre3"
  }, [_c('span', {
    attrs: {
      "id": "pgepubid00094",
      "title": "[87]"
    }
  }, [_c('a', {
    staticClass: "reference",
    attrs: {
      "id": "Page_87"
    }
  })])]), _vm._v(" "), _c('h2', {
    staticClass: "nobreak",
    attrs: {
      "id": "III"
    }
  }, [_vm._v("III"), _c('br', {
    staticClass: "calibre7"
  }), _vm._v(" "), _c('span', {
    staticClass: "smaller"
  }, [_vm._v("LETTER TO MARTIN VAN BUREN,"), _c('br', {
    staticClass: "calibre7"
  }), _vm._v("\nPRESIDENT OF THE UNITED STATES")])]), _vm._v(" "), _c('p', {
    staticClass: "subheading"
  }, [_vm._v("A PROTEST AGAINST THE REMOVAL OF THE\nCHEROKEE INDIANS FROM THE\nSTATE OF GEORGIA")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_c('span', {
    attrs: {
      "id": "pgepubid00095",
      "title": "[88]"
    }
  }, [_c('a', {
    staticClass: "reference",
    attrs: {
      "id": "Page_88"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "calibre5"
  }, [_c('div', {
    staticClass: "poetry"
  }, [_c('div', {
    staticClass: "stanza"
  }, [_c('div', {
    staticClass: "verse"
  }, [_vm._v("“Say, what is Honour? ’Tis the finest sense")]), _vm._v(" "), _c('div', {
    staticClass: "verse"
  }, [_vm._v("Of justice which the human mind can frame,")]), _vm._v(" "), _c('div', {
    staticClass: "verse"
  }, [_vm._v("Intent each lurking frailty to disclaim,")]), _vm._v(" "), _c('div', {
    staticClass: "verse"
  }, [_vm._v("And guard the way of life from all offence,")]), _vm._v(" "), _c('div', {
    staticClass: "verse"
  }, [_vm._v("Suffered or done.”")])]), _vm._v(" "), _c('div', {
    staticClass: "stanza"
  }, [_c('div', {
    staticClass: "verse1"
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Wordsworth.")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_c('span', {
    attrs: {
      "id": "pgepubid00096",
      "title": "[89]"
    }
  }, [_c('a', {
    staticClass: "reference",
    attrs: {
      "id": "Page_89"
    }
  })])]), _vm._v(" "), _c('h3', {
    staticClass: "calibre14 sigil_not_in_toc",
    attrs: {
      "id": "pgepubid00097"
    }
  }, [_vm._v("LETTER"), _c('br', {
    staticClass: "calibre7"
  }), _vm._v(" "), _c('span', {
    staticClass: "smaller1"
  }, [_vm._v("TO MARTIN VAN BUREN,"), _c('br', {
    staticClass: "calibre8"
  }), _vm._v("\nPRESIDENT OF THE UNITED STATES")])]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Concord, Mass.")]), _vm._v(", April 23, 1838.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Sir")]), _vm._v(": The seat you fill places you in a relation\nof credit and nearness to every citizen.\nBy right and natural position, every citizen is\nyour friend. Before any acts contrary to his own\njudgment or interest have repelled the affections\nof any man, each may look with trust and living\nanticipation to your government. Each has the\nhighest right to call your attention to such\nsubjects as are of a public nature, and properly\nbelong to the chief magistrate; and the good\nmagistrate will feel a joy in meeting such confidence.\nIn this belief and at the instance of\na few of my friends and neighbors, I crave of\nyour patience a short hearing for their sentiments\nand my own: and the circumstance that\nmy name will be utterly unknown to you will\nonly give the fairer chance to your equitable\nconstruction of what I have to say.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Sir, my communication respects the sinister\nrumors that fill this part of the country concerning\nthe Cherokee people. The interest"), _c('span', {
    attrs: {
      "id": "pgepubid00098",
      "title": "[90]"
    }
  }, [_c('a', {
    staticClass: "reference",
    attrs: {
      "id": "Page_90"
    }
  })]), _vm._v("\nalways felt in the aboriginal population—an\ninterest naturally growing as that decays—has\nbeen heightened in regard to this tribe. Even\nin our distant State some good rumor of their\nworth and civility has arrived. We have learned\nwith joy their improvement in the social arts.\nWe have read their newspapers. We have seen\nsome of them in our schools and colleges. In\ncommon with the great body of the American\npeople, we have witnessed with sympathy the\npainful labors of these red men to redeem their\nown race from the doom of eternal inferiority,\nand to borrow and domesticate in the tribe the\narts and customs of the Caucasian race. And\nnotwithstanding the unaccountable apathy with\nwhich of late years the Indians have been sometimes\nabandoned to their enemies, it is not to\nbe doubted that it is the good pleasure and the\nunderstanding of all humane persons in the\nRepublic, of the men and the matrons sitting\nin the thriving independent families all over the\nland, that they shall be duly cared for; that\nthey shall taste justice and love from all to\nwhom we have delegated the office of dealing\nwith them.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("The newspapers now inform us that, in\nDecember, 1835, a treaty contracting for the"), _c('span', {
    attrs: {
      "id": "pgepubid00099",
      "title": "[91]"
    }
  }, [_c('a', {
    staticClass: "reference",
    attrs: {
      "id": "Page_91"
    }
  })]), _vm._v("\nexchange of all the Cherokee territory was pretended\nto be made by an agent on the part of\nthe United States with some persons appearing\non the part of the Cherokees; that the fact\nafterwards transpired that these deputies did by\nno means represent the will of the nation; and\nthat, out of eighteen thousand souls composing\nthe nation, fifteen thousand six hundred and\nsixty-eight have protested against the so-called\ntreaty. It now appears that the government\nof the United States choose to hold the Cherokees\nto this sham treaty, and are proceeding to\nexecute the same. Almost the entire Cherokee\nNation stand up and say, “This is not our act.\nBehold us. Here are we. Do not mistake that\nhandful of deserters for us;” and the American\nPresident and the Cabinet, the Senate and the\nHouse of Representatives, neither hear these\nmen nor see them, and are contracting to put\nthis active nation into carts and boats, and to\ndrag them over mountains and rivers to a wilderness\nat a vast distance beyond the Mississippi.\nAnd a paper purporting to be an army\norder fixes a month from this day as the hour\nfor this doleful removal.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("In the name of God, sir, we ask you if this\nbe so. Do the newspapers rightly inform us?"), _c('span', {
    attrs: {
      "id": "pgepubid00100",
      "title": "[92]"
    }
  }, [_c('a', {
    staticClass: "reference",
    attrs: {
      "id": "Page_92"
    }
  })]), _vm._v("\nMen and women with pale and perplexed faces\nmeet one another in the streets and churches\nhere, and ask if this be so. We have inquired\nif this be a gross misrepresentation from the\nparty opposed to the government and anxious\nto blacken it with the people. We have looked\nin the newspapers of different parties and find\na horrid confirmation of the tale. We are slow\nto believe it. We hoped the Indians were misinformed,\nand that their remonstrance was premature,\nand will turn out to be a needless act\nof terror.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("The piety, the principle that is left in the\nUnited States, if only in its coarsest form, a regard\nto the speech of men,—forbid us to entertain\nit as a fact. Such a dereliction of all faith\nand virtue, such a denial of justice, and such\ndeafness to screams for mercy were never heard\nof in times of peace and in the dealing of a nation\nwith its own allies and wards, since the earth\nwas made. Sir, does this government think that\nthe people of the United States are become\nsavage and mad? From their mind are the sentiments\nof love and a good nature wiped clean\nout? The soul of man, the justice, the mercy\nthat is the heart’s heart in all men, from Maine\nto Georgia, does abhor this business.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_c('span', {
    attrs: {
      "id": "pgepubid00101",
      "title": "[93]"
    }
  }, [_c('a', {
    staticClass: "reference",
    attrs: {
      "id": "Page_93"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("In speaking thus the sentiments of my neighbors\nand my own, perhaps I overstep the bounds\nof decorum. But would it not be a higher indecorum\ncoldly to argue a matter like this? We\nonly state the fact that a crime is projected that\nconfounds our understandings by its magnitude,—a\ncrime that really deprives us as well as the\nCherokees of a country? for how could we call\nthe conspiracy that should crush these poor\nIndians our government, or the land that was\ncursed by their parting and dying imprecations\nour country, any more? You, sir, will bring\ndown that renowned chair in which you sit into\ninfamy if your seal is set to this instrument of\nperfidy; and the name of this nation, hitherto\nthe sweet omen of religion and liberty, will stink\nto the world.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("You will not do us the injustice of connecting\nthis remonstrance with any sectional and party\nfeeling. It is in our hearts the simplest commandment\nof brotherly love. We will not have\nthis great and solemn claim upon national and\nhuman justice huddled aside under the flimsy\nplea of its being a party act. Sir, to us the\nquestions upon which the government and the\npeople have been agitated during the past year,\ntouching the prostration of the currency and of"), _c('span', {
    attrs: {
      "id": "pgepubid00102",
      "title": "[94]"
    }
  }, [_c('a', {
    staticClass: "reference",
    attrs: {
      "id": "Page_94"
    }
  })]), _vm._v("\ntrade, seem but motes in comparison. These\nhard times, it is true, have brought the discussion\nhome to every farmhouse and poor\nman’s house in this town; but it is the chirping\nof grasshoppers beside the immortal question\nwhether justice shall be done by the race of\ncivilized to the race of savage man,—whether all\nthe attributes of reason, of civility, of justice,\nand even of mercy, shall be put off by the\nAmerican people, and so vast an outrage upon\nthe Cherokee Nation and upon human nature\nshall be consummated.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("One circumstance lessens the reluctance with\nwhich I intrude at this time on your attention\nmy conviction that the government ought to be\nadmonished of a new historical fact, which the\ndiscussion of this question has disclosed, namely,\nthat there exists in a great part of the Northern\npeople a gloomy diffidence in the "), _c('i', {
    staticClass: "calibre9"
  }, [_vm._v("moral")]), _vm._v(" character\nof the government.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("On the broaching of this question, a general\nexpression of despondency, of disbelief that any\ngood will accrue from a remonstrance on an act\nof fraud and robbery, appeared in those men to\nwhom we naturally turn for aid and counsel.\nWill the American government steal? Will it\nlie? Will it kill?—We ask triumphantly. Our"), _c('span', {
    attrs: {
      "id": "pgepubid00103",
      "title": "[95]"
    }
  }, [_c('a', {
    staticClass: "reference",
    attrs: {
      "id": "Page_95"
    }
  })]), _vm._v("\ncounsellors and old statesmen here say that ten\nyears ago they would have staked their lives on\nthe affirmation that the proposed Indian measures\ncould not be executed; that the unanimous\ncountry would put them down. And now the\nsteps of this crime follow each other so fast, at\nsuch fatally quick time, that the millions of virtuous\ncitizens, whose agents the government are,\nhave no place to interpose, and must shut their\neyes until the last howl and wailing of these\ntormented villages and tribes shall afflict the ear\nof the world.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("I will not hide from you, as an indication of\nthe alarming distrust, that a letter addressed as\nmine is, and suggesting to the mind of the\nExecutive the plain obligations of man, has a\nburlesque character in the apprehensions of some\nof my friends. I, sir, will not beforehand treat\nyou with the contumely of this distrust. I will\nat least state to you this fact, and show you how\nplain and humane people, whose love would\nbe honor, regard the policy of the government,\nand what injurious inferences they draw as to\nthe minds of the governors. A man with your\nexperience in affairs must have seen cause to\nappreciate the futility of opposition to the moral\nsentiment. However feeble the sufferer and"), _c('span', {
    attrs: {
      "id": "pgepubid00104",
      "title": "[96]"
    }
  }, [_c('a', {
    staticClass: "reference",
    attrs: {
      "id": "Page_96"
    }
  })]), _vm._v("\nhowever great the oppressor, it is in the nature\nof things that the blow should recoil upon the\naggressor. For God is in the sentiment, and\nit cannot be withstood. The potentate and the\npeople perish before it; but with it, and as its\nexecutor, they are omnipotent.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("I write thus, sir, to inform you of the state\nof mind these Indian tidings have awakened\nhere, and to pray with one voice more that you,\nwhose hands are strong with the delegated power\nof fifteen millions of men, will avert with that\nmight the terrific injury which threatens the\nCherokee tribe.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("With great respect, sir, I am your fellow\ncitizen,")]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_vm._v("RALPH WALDO EMERSON.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a5c71e0a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/Section0006.vue
// module id = 72
// module chunks = 0